<template>
  <div class="selectListComponent" id="fieledSelectComponent" :style="widthOverRight?'right:0':'left:0'">
    <el-form :inline="true" size="mini">
      <div class="closeBtn" @click="close">
        <i class="el-icon-close fr"></i>
      </div>
      <el-form-item label="字段来源：">
        <el-radio-group v-model="fieldType" @change="searchHandle">
          <el-radio-button label="input" v-if="!showOne||showOne=='input'">输入字段</el-radio-button>
          <el-radio-button label="output" v-if="!showOne||showOne=='output'">输出字段</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <br />
      <el-form-item>
        <el-input
          @keyup.enter.native="searchHandle"
          clearable
          v-model.trim="name"
          placeholder="关键字"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-search"
          @click="searchHandle"
          plain
          :loading="searchOnoff"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div
      class="infinite-list"
      v-infinite-scroll="loadList"
      v-if="list.length > 0"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="selectItem(item)"
        class="infinite-list-item"
      >
        <div>{{ item.nameCn }} <span class="nameEn">{{ item.nameEn }}</span> <span class="primaryC nameEn">{{item.type}}</span></div>
      </div>
    </div>
    <div class="infinite-list noData" v-if="list.length <= 0">暂无数据</div>
  </div>
</template>

<script>
export default {
  props:['showOne'],
  data() {
    return {
      widthOverRight:false,
      workspaceId:'',
      fieldType: "input",
      onOff: true,
      searchOnoff:false,
      name:"",
      pageNum: 1,
      pageSize: 20,
      totalNum: 10,
      list: [],
    };
  },
  
  created() {
    this.workspaceId=this.utils.getSpaceInfo().id;
    if(this.showOne){
      this.fieldType=this.showOne;
    }
    this.searchHandle();
  },
  mounted () {
    const seletW=document.getElementById('fieledSelectComponent').clientWidth
    const clientX=localStorage.last_inputclick_showFieldSelect_clientX/1
    const pageW=document.documentElement.clientWidth/1
    const overRightOnoff=(clientX+seletW)>pageW-30
    this.widthOverRight=overRightOnoff
  },
  methods: {
    searchHandle() {
      
      this.list = [];
      this.pageNum = 1;
      this.totalNum = 10;
      this.getList();
    },
    loadList() {
      this.pageNum += 1;
      console.log(this.totalNum,this.pageNum)
      if (this.totalNum >= this.pageNum) this.getList();
    },
    selectItem(item) {
      item.label = item.nameEn
      const res=`${this.fieldType}.${item.nameEn}`
      const resName=`${item.nameCn}`
      this.$emit("update:fieldVal",res )
      this.$emit("update:fieldName",resName )
      this.$emit("update:fieldType",item.type )
      this.$emit("update:accuracy",item.accuracy )
      const selectRes={
        fieldVal:res,
        fieldName:resName,
        fieldType:item.type,
        accuracy:item.accuracy,
      }
      this.close(selectRes)
    },
    close(selectRes) {
      const res=selectRes||{}
      this.$emit("close",res)
    },
    getList(callback) {
      if(this.searchOnoff) return
      this.searchOnoff=true
      let arg = {
        key: this.searchKey,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.name,
        workspaceId: this.workspaceId
      }
      var url = ""
      if (this.fieldType == "input") {
        url = "/admin/fieldInput/list"
      } else if (this.fieldType == "output") {
        url = "/admin/fieldOutput/list"
      }
      this.request({
        url: url,
        method: "post",
        params: arg
      }).then((res) => {
        const resD = res.data
        this.totalNum = Math.ceil(resD.total/this.pageSize)
        this.list = this.list.concat(resD.list)
        this.searchOnoff=false
      }).catch(err=>{
        this.searchOnoff=false
      })
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
.selectListComponent{
  .nameEn{
    color: #888;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FieldSelect/index.vue